import { Component, OnInit, OnDestroy } from '@angular/core';
import { Schedule } from 'src/app/models/schedule-models/schedule.model';
import { EMPTY, Subscription } from 'rxjs';
import { BroadcastingsService } from 'src/app/services/broadcastings-services/broadcastings.service';
import { ActivatedRoute } from '@angular/router';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { HeaderBreadcrumbService } from '../../header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { tap } from 'rxjs/internal/operators/tap';
import { catchError } from 'rxjs/internal/operators/catchError';

@Component({
  selector: 'app-broadcastings-broadcasting-schedule-dashboard',
  templateUrl: './broadcastings-broadcasting-schedule-dashboard.component.html',
  styleUrls: ['./broadcastings-broadcasting-schedule-dashboard.component.scss']
})
export class BroadcastingsBroadcastingScheduleDashboardComponent implements OnInit, OnDestroy {

  broadcastingid;
  schedule: Schedule;
  getBroadcastingScheduleSubscription: Subscription;

  constructor(private broadcastingsService: BroadcastingsService,
              private activatedRoute: ActivatedRoute,
              private snackbarService: SnackBarService,
              private headerBreadcrumbService: HeaderBreadcrumbService) { }

  ngOnInit() {
    this.broadcastingid = this.activatedRoute.snapshot.params['broadcastingid'];
    this.setBreadcrumb();
    this.getSchedule();
  }

  public getSchedule() {
    const internalId = this.activatedRoute.snapshot.params['scheduleid'];
    const relatedEntityInternalId = this.activatedRoute.snapshot.params['broadcastingid'];
    this.getBroadcastingScheduleSubscription = this.broadcastingsService.getBroadcastingScheduleInfo(internalId, relatedEntityInternalId).pipe(
      tap(o => this.schedule = o),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-calendar-day', 'schedule-page.schedule detail', '/broadcastings/broadcasting/' + this.broadcastingid, [new BRoute('broadcastings-page.broadcastings', '/broadcastings'), new BRoute('broadcastings-page.broadcastings', '/broadcastings/broadcastings'), new BRoute('broadcastings-page.broadcasting detail', '/broadcastings/broadcasting/' + this.broadcastingid), new BRoute('schedule-page.schedule detail')]));
  }

  ngOnDestroy() {
    if (this.getBroadcastingScheduleSubscription) { this.getBroadcastingScheduleSubscription.unsubscribe(); }
  }
}
